const OPTIONS_VALUE = {
  SELECCIONAR: 'SELECCIONAR',
  GRABAR: 'GRABAR',
};
const OPTIONS = [
  { label: 'Seleccionar archivo de audio (MP3 - peso máximo: 20MB)', value: OPTIONS_VALUE.SELECCIONAR },
  { label: 'Grabar mensaje de audio', value: OPTIONS_VALUE.GRABAR },
];

export { OPTIONS_VALUE, OPTIONS };
